import { TableRow } from '@mui/material';

import { RowTableCell } from '../../../../common/components';

const TableStateRow = ({ colSpan, loading, emptyMessage }) => (
  <TableRow>
    <RowTableCell colSpan={colSpan} sx={{ textAlign: 'center', py: 3 }}>
      {loading ? 'Cargando...' : emptyMessage}
    </RowTableCell>
  </TableRow>
);

export default TableStateRow;
